import type { ComponentProps, ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function Panel({ className, ...props }: ComponentProps<'section'>) {
  return <section data-slot="panel" className={cn('min-w-0 rounded-card border border-hairline-faint bg-card text-card-foreground', className)} {...props} />;
}

export function PanelHeader({ title, description, actions, className }: {
  title: ReactNode; description?: ReactNode; actions?: ReactNode; className?: string;
}) {
  return (
    <div data-slot="panel-header" className={cn('flex min-w-0 flex-wrap items-center justify-between gap-3 border-b border-hairline p-panel', className)}>
      <div className="min-w-0 flex-1">
        <h2 className="type-ui break-words font-medium text-foreground">{title}</h2>
        {description && <p className="mt-1 break-words text-caption text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}

export function PanelBody({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="panel-body" className={cn('min-w-0 p-panel', className)} {...props} />;
}

/** Layout only: a toolbar role would require additional arrow-key behavior. */
export function ActionBar({ className, ...props }: ComponentProps<'div'>) {
  return <div data-slot="action-bar" className={cn('flex flex-wrap items-center justify-end gap-2', className)} {...props} />;
}

export function PreferenceRow({ title, description, children, className }: {
  title: ReactNode; description?: ReactNode; children: ReactNode; className?: string;
}) {
  return (
    <div data-slot="preference-row" className={cn('flex min-h-16 flex-col gap-3 border-b border-hairline py-4 last:border-0 sm:flex-row sm:items-center sm:justify-between sm:gap-8', className)}>
      <div className="min-w-0"><p className="text-ui font-medium text-foreground">{title}</p>
        {description && <p className="type-caption mt-1 max-w-xl text-muted-foreground">{description}</p>}
      </div>
      <div className="min-w-0 sm:shrink-0">{children}</div>
    </div>
  );
}
